import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DetailFieldText from 'fixedassets/components/detail/field/DetailFieldText';

const DetailFieldCatalog = ({ label, value, t }) => {
  return <DetailFieldText label={label} value={value ? `${t(value.value)}` : null} />;
};

DetailFieldCatalog.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

export default translate()(DetailFieldCatalog);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/DetailFieldCatalog.js